import { isEmpty } from "lodash"
import { z } from "zod"

const ERROR = {
  name: "Please enter a valid name",
  email: "Please enter a valid email address",
  telephone: "Please enter a valid phone number",
  message: "Please enter a valid message",
  propertyAddress: "Please enter a valid address",
  date: "Please enter a valid date",
  time: "Please enter a valid time",
  string: "Please enter a valid text",
  select: "Please select a valid option",
  number: "Please enter a valid number",
  jobTitle: "Please enter a valid job title",
  companyName: "Please enter a valid company name",
  postCodeInput: "Please enter a valid post code"
 
}

export const SCHEMA = {
  nullish: z.string().nullish(),
  name: z.string({ message: ERROR.name }).min(1, { message: ERROR.name }),
  optionalName: z.string({ message: ERROR.name }).optional(),
  email: z.string().email({ message: ERROR.email }),
  optionalEmail: z.string().email({ message: ERROR.email }).optional(),
  telephone: z
    .string({ message: ERROR.telephone, invalid_type_error: ERROR.telephone })
    .min(6, { message: ERROR.telephone })
    .refine(
      (value) => {
        const phoneRegex = /^\+?[0-9]+([- ]?[0-9]+)*$/
        return phoneRegex.test(value)
      },
      { message: ERROR.telephone },
    ),
  message: z.string({ message: ERROR.message }),
  propertyAddress: z.string({ message: ERROR.propertyAddress }).optional(),
  date: z.string({ message: ERROR.date }),
  time: z.string({ message: ERROR.time }),
  attachment: z
    .any()
    .refine((files) => {
      return !isEmpty(files)
    }, "Please select a file.")
    .refine((files) => {
      return files?.[0]?.size <= 5000000
    }, "Max file size is 5MB."),
  // .refine(
  //   files => ACCEPTED_IMAGE_TYPES.includes(files?.[0]?.type),
  //   ".jpg, .jpeg, .png and .webp files are accepted."
  // ),
  images: z
    .any().optional(),
    // .refine((files) => {
    //   return !isEmpty(files)
    // }, "Please select a file.")
    // .refine((files) => {
    //   return files?.[0]?.size <= 5000000
    // }, "Max file size is 5MB."),
  nationality: z
    .string({ message: ERROR.name })
    .min(1, { message: ERROR.name }),
  string: z.coerce
    .string({ message: ERROR.string })
    .min(1, { message: ERROR.string }),
  optionalString: z.coerce.string({ message: ERROR.string }).optional(),
  stringArray: z.array(z.string({ message: ERROR.string })).nonempty({
    message: "Please select at least one option",
  }),
  arrayObjValue: z.array(
    z.object({
      value: z.coerce
        .string({ message: ERROR.string })
        .min(1, { message: ERROR.string }),
    }),
  ), 
  select: z.string({ message: ERROR.select }).min(1, { message: ERROR.select }),
  optionalSelect: z.string({ message: ERROR.select }).optional(),
  selectInt: z.number({ message: ERROR.select }),
  number: z.coerce
    .number({ message: ERROR.number, invalid_type_error: ERROR.number })
    .positive({ message: ERROR.number }),
  decimal: z.coerce
    .number({ message: ERROR.number, invalid_type_error: ERROR.number })
    .finite()
    .positive({ message: ERROR.number }),
  jobTitle: z
    .string({ message: ERROR.jobTitle })
    .min(1, { message: ERROR.jobTitle }),
  companyName: z
    .string({ message: ERROR.companyName })
    .min(1, { message: ERROR.companyName }),
  postCodeInput: z
    .string({ message: ERROR.postCodeInput })
    .min(1, { message: ERROR.postCodeInput }), 
}
